import styled from 'styled-components'

export const ContentMain = styled.main`
    flex: 1;
    background: #eef3fb;
    border-radius: 18px;
    padding: 20px;
    min-height: 500px;
    box-shadow: inset 0 0 0 1px #d8e3f2;
    overflow: hidden;
`

export const SelectedTableTitle = styled.div`
    margin-bottom: 16px;
    font-size: 20px;
    font-weight: 700;
    color: #355486;

    span {
        color: #4a6fb0;
    }
`
